import { useState } from "react";
import XInput from "./XInput";
import RenderIf from "../render-if/Renderif";
import { cn } from "../../utils/classNames";

const iconPositionClasses = 'absolute left-[95%] top-1/2 -translate-y-1/2 bg-white';

const searchIconClasses = `fa-solid fa-magnifying-glass ${iconPositionClasses} text-primary`;

const clearButtonClasses = `${iconPositionClasses} text-primary cursor-pointer`;

const searchWrapperClasses = 'relative';

const searchWidthClasses = 'w-3/5';

const searchInputClasses = 'h-10 text-content text-base rounded pl-2.5 ml-2.5';

// className replaces the default width, so a caller that wraps this for layout
// or an anchor can hand the sizing to the wrapper instead
const SearchBox = ({ value, defaultValue = "", onChange, onBlur, placeholder = "Search", className = searchWidthClasses }) => {
   const [internalValue, setInternalValue] = useState(defaultValue);
   const isControlled = value !== undefined;
   const inputValue = isControlled ? value : internalValue;
   const hasText = Boolean(inputValue);

   const handleChange = (e) => {
      if (!isControlled) setInternalValue(e.target.value);
      if (onChange) onChange(e);
   };

   const handleClear = () => {
      if (!isControlled) setInternalValue("");
      if (onChange) onChange({ target: { value: "" } });
   };

   return (
      <div className={cn(searchWrapperClasses, className)}>
         <XInput
            type="text"
            className={searchInputClasses}
            placeholder={placeholder}
            value={inputValue}
            onChange={handleChange}
            onBlur={onBlur}
         />
         <RenderIf shouldRender={hasText}>
            <button
               type="button"
               className={clearButtonClasses}
               aria-label="Clear search"
               onMouseDown={(e) => e.preventDefault()}
               onClick={handleClear}
            >
               <i className="fa-solid fa-xmark" />
            </button>
         </RenderIf>
         <RenderIf shouldRender={!hasText}>
            <i className={searchIconClasses}></i>
         </RenderIf>
      </div>
   );
};

export default SearchBox;
